import baseApi from 'services/api/base';
import getProductKey from 'helper/requests/getProductKey';
import { WBSequentialDVOptions } from 'types/Meteorology/Agro/WaterBalanceSequential/DetailedView/getOptions';
import transformGetOptionsResponse, { transformGetWBSequentialGraphResponse } from 'helper/Meteorology/Agro/WaterBalanceSequential/DetailedView';
import { GetSequentialGraphParams, SequentialGraph } from 'types/Meteorology/Agro/WaterBalanceSequential/DetailedView/getGraph';

export const waterBalanceSequentialDetailedViewApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getWBSequentialDVOptions: build.query<WBSequentialDVOptions, void>({
      query: () => {
        const productKey = getProductKey('agro');
        return {
          url: `produtos/agro/balanco-hidrico/sequencial/visao-detalhada/painel-options/?product_key=${productKey}`,
          method: 'GET',
        };
      },
      transformResponse: transformGetOptionsResponse,
    }),
    getWBSequentialGraph: build.query<SequentialGraph, GetSequentialGraphParams>({
      query: ({
        groupId, locationId, soilId, startDate, endDate,
      }) => {
        const productKey = getProductKey('agro');
        return {
          url: `produtos/agro/balanco-hidrico/sequencial/visao-detalhada/serie-temporal/?product_key=${productKey}`,
          method: 'POST',
          body: {
            grupo_id: groupId,
            local_id: locationId,
            solo_id: soilId,
            data_inicial: startDate,
            data_final: endDate,
          },
        };
      },
      transformResponse: transformGetWBSequentialGraphResponse,
    }),
  }),
});

export const {
  useGetWBSequentialDVOptionsQuery,
  useGetWBSequentialGraphQuery,
  useLazyGetWBSequentialGraphQuery,
} = waterBalanceSequentialDetailedViewApi;
